module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};



// WEBPACK FOOTER //
// ./~/es-abstract/helpers/isPrimitive.js